import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *apolloMutation(mutation, $completion) {
  return yield* this.y6s().c67(mutation).m43('Authorization', 'Bearer ' + (yield* this.z6s($completion))).m63($completion);
}
function *apolloQuery(query, $completion) {
  return yield* this.y6s().b67(query).m43('Authorization', 'Bearer ' + (yield* this.z6s($completion))).m63($completion);
}
var KtorQueryPerformerClass;
function KtorQueryPerformer() {
  if (KtorQueryPerformerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KtorQueryPerformer', VOID, VOID, VOID, [1, 0]);
    KtorQueryPerformerClass = $;
  }
  return KtorQueryPerformerClass;
}
//region block: exports
export {
  KtorQueryPerformer as KtorQueryPerformer3enpohylr2sy5,
  apolloMutation as apolloMutation1pfb2yrb4utuy,
  apolloQuery as apolloQuery1ngnajaedsnmj,
};
//endregion

//# sourceMappingURL=KtorQueryPerformer.mjs.map
